import { h } from '@externs/preact'
import Popup from '@lemuria/popup'

/**
 * This one is to mount components. Export for splendid.
 */
export default function SocialButtons({
  size = 32, url, subject, title, borderRadius, meta, splendid: { mount }, ...props
}) {
  delete props.splendid
  if (meta) {
    const el = document.querySelector('meta[name="description"]')
    if (!el) return ( h('span',{...props},
      `Error Loading Social Buttons (no meta description)`
    ))
    title = el.content
    if (!subject) subject = el.content
  }
  return (                                      h('span',{...props},
    Object.entries(LINKS).reduce((acc, [key, { color, ...link }]) => {
      const c = `rgb(${color})`
      acc.push(h(A,{...link,size:size,svg:key,color:c,mount:mount,title:title,url:url,subject:subject,borderRadius:borderRadius,isEmail:key == 'email'}), ' ')
      return acc
    }, []),
  ))
}

const A = ({
  url, title, subject, size, href, svg, color, alt, width = 900, height = 650, borderRadius = '4px', isEmail, mount = '/',
}) => {
  const hr = href(url, title, subject)
  const src = `${mount}buttons/${svg}.svg`
  const style = `background:${color}; border-radius:${borderRadius}`
  const img = (h('img',{'src':src, 'width':size, 'height':size, 'alt':alt,
    'style':style }))
  if (isEmail) {
    return (h('a',{'href':hr},img))
  }
  return (h('a',{ 'onClick':(e) => {
    Popup(hr, alt, width, height)
    e.preventDefault()
    return false
  },'href':"#"},
    img,
  ))
}

const serialise = (obj) => {
  return Object.entries(obj).map(([key, value]) => {
    if (!value) return
    return `${key}=${value}`
  }).filter(Boolean).join('&')
}

export const LINKS = {
  'facebook': {
    href(url, text) {
      const params = serialise({ 'u': url, 'quote': text })
      return `https://www.facebook.com/sharer/sharer.php?${params}`
      // return `https://www.facebook.com/dialog/share?app_id=225755674993808&display=popup&href=${h}`
    },
    color: [59, 89, 152],// 'rgb(59, 89, 152)',
    alt: 'Share on Facebook',
  },
  'twitter': {
    href(url, text) {
      const params = serialise({ 'text': text, 'url': url })
      return `https://twitter.com/intent/tweet?${params}`
    },
    color: [85, 172, 238], //'rgb(85, 172, 238)',
    alt: 'Share on Twitter',
    width: 550,
    height: 420,
  },
  'linkedin': {
    href(url, title) {
      const params = serialise({ 'url': url, 'mini': true, 'title': title })
      return `https://www.linkedin.com/shareArticle?${params}`
    },
    color: [0, 123, 181],// 'rgb(0, 123, 181)',
    alt: 'Share on LinkedIn',
  },
  'whatsapp': {
    href(url, title) {
      const params = serialise({ 'text': [title, url].filter(Boolean).join(' ') })
      return `https://api.whatsapp.com/send?${params}`
    },
    color: [18, 175, 10], // 'rgb(18, 175, 10)',
    alt: 'Share on Whatsapp',
  },
  'email': {
    href(url, title, subject) {
      const params = serialise({
        'subject': subject,
        'body': [title, url].filter(Boolean).join(' '),
      })
      // const s = subject ? `subject=${subject}&amp;` : ''
      return `mailto:?${params}`
    },
    color: [1, 102, 255], //'rgb(1, 102, 255)',
    alt: 'Share on Email',
  },
}